import { render, staticRenderFns } from "./DueDates.vue?vue&type=template&id=2eea82af"
import script from "./DueDates.vue?vue&type=script&lang=js"
export * from "./DueDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports